export const statusDescriptions: { [key: number]: string } = {
  1: "Pending action by Line Approver",
  10: "Approved by Line Approver",
  12: "Approved by Finance Analyst",
  14: "Approved by Joint Venture Analyst",
  16: "Approved by PSC Analyst",
  18: "Approved by GAS Analyst",
  20: "Approved by Interco Analyst",
  22: "Approved by Allocations Analyst",
  24: "Approved by Fixed Assets Analyst",
  26: "Approved by Production Accounting Analyst",
  28: "Approved by JDE Analyst",
  11: "Pending Finance Analyst Approval",
  13: "Pending Joint Venture Approval",
  15: "Pending PSC Approval",
  17: "Pending GAS Approval",
  19: "Pending Interco Approval",
  21: "Pending Allocations Approval",
  23: "Pending Fixed Assets Approval",
  25: "Pending Production Accounting Approval",
  27: "Pending JDE Approval",
  [-10]: "Disapproved by Line Approver",
  [-12]: "Disapproved by Finance Analyst",
  [-14]: "Disapproved by Joint Venture Analyst",
  [-16]: "Disapproved by PSC Analyst",
  [-18]: "Disapproved by GAS Analyst",
  [-20]: "Disapproved by Interco Analyst",
  [-22]: "Disapproved by Allocations Analyst",
  [-24]: "Disapproved by Fixed Assets Analyst",
  [-26]: "Disapproved by Production Accounting Analyst",
  [-28]: "Disapproved by JDE Analyst",
  99: "Pending Final review",
  100: "Completed and Closed",
  0: "Returned",
  [-100]: "Cancelled",
};

export const actionDescriptions: { [key: string]: string } = {
  A: "Add",
  U: "Update",
  D: "Deactivate",
};
